import { Box } from "@mui/material";
import React from "react";
import classess from "./Style.module.css";

const IMs = () => {
  const Title = ["حالت", "in + Artikel", "خلاضه ش"];
  const ST1 = ["Dativ + der (مذکر)", "in dem Park", "im Park"];
  const ST2 = ["Dativ + das (خنثی)", "in dem Kino", "im Kino"];
  const ST3 = ["Artikel", "Dativ", "ترکیب", "خلاصه ش"];
  const ST4 = ["der (مذکر)", "dem", "im", "im Park"];
  const ST5 = ["das (خنثی)", "dem", "im", "im Büro"];
  const ST6 = ["die (مونث)", "der", "in der", "in der Schule"];
  const ST7 = ["die (جمع)", "den", "in den", "in den Bergen"];

  return (
    <Box className={classess.Wrapper}>
      <span>جدول حالت‌های اسم مذکر با „ein“:</span>
      <Box className={classess.WP}>
        {Title.map((opt, index) => (
          <Box
            key={index}
            className={classess.WB}
            sx={{
              width: index === 0 ? "130px" : "100px",
              backgroundColor: "rgba(150, 150, 150, 0.1)",
              fontSize: "0.9rem",
            }}
          >
            {opt}
          </Box>
        ))}
      </Box>
      <Box className={classess.WP}>
        {ST1.map((opt, index) => (
          <Box
            key={index}
            className={classess.WB}
            sx={{
              width: index === 0 ? "130px" : "100px",
              fontSize: "1.1rem",
            }}
          >
            {opt}
          </Box>
        ))}
      </Box>
      <Box className={classess.WP}>
        {ST2.map((opt, index) => (
          <Box
            key={index}
            className={classess.WB}
            sx={{
              width: index === 0 ? "130px" : "100px",
              fontSize: "1.1rem",
            }}
          >
            {opt}
          </Box>
        ))}
      </Box>
      <span style={{ marginTop: "15px" }}>خلاصه</span>
      <Box className={classess.WP}>
        {ST3.map((opt, index) => (
          <Box
            key={index}
            className={classess.WB}
            sx={{
              width: "80px",
              backgroundColor: "rgba(150, 150, 150, 0.1)",
              fontSize: "0.9rem",
            }}
          >
            {opt}
          </Box>
        ))}
      </Box>
      <Box className={classess.WP}>
        {ST4.map((opt, index) => (
          <Box
            key={index}
            className={classess.WB}
            sx={{
              width: "80px",
              fontSize: "1.1rem",
            }}
          >
            {opt}
          </Box>
        ))}
      </Box>
      <Box className={classess.WP}>
        {ST5.map((opt, index) => (
          <Box
            key={index}
            className={classess.WB}
            sx={{
              width: "80px",
              fontSize: "1.1rem",
            }}
          >
            {opt}
          </Box>
        ))}
      </Box>
      <Box className={classess.WP}>
        {ST6.map((opt, index) => (
          <Box
            key={index}
            className={classess.WB}
            sx={{
              width: "80px",
              fontSize: index === 3 ? "0.9rem" : "1.1rem",
            }}
          >
            {opt}
          </Box>
        ))}
      </Box>
      <Box className={classess.WP}>
        {ST7.map((opt, index) => (
          <Box
            key={index}
            className={classess.WB}
            sx={{
              width: "80px",
              fontSize: index === 3 ? "0.9rem" : "1.1rem",
            }}
          >
            {opt}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default IMs;
